import { useViewAnalyticsTimestamps } from "@/features/account-management";
import {
  useAdoptUrlSelection,
  useDeepLinkSelection,
  useResetStore,
  useShowPlaceholderData,
} from "../hooks";
import { AudienceOverview } from "./audience-overview";
import { Devices } from "./devices";
import { EngagementFunnel } from "./engagement-funnel";
import { Filters } from "./filters";
import { Header } from "./header";
import PlaceholderDataNote from "./placeholder-data-note";
import { ReadersOverview } from "./readers-overview";
import { TrafficType } from "./traffic-type";
import { VersionsTable } from "./versions-table";

const Analytics = () => {
  useViewAnalyticsTimestamps();
  const showPlaceholder = useShowPlaceholderData();
  useResetStore();
  // Before the hook that labels the selection: that one reads the ids out of the
  // store, and on a click through from the Stories list this is what puts them
  // there.
  useAdoptUrlSelection();
  useDeepLinkSelection();
  return (
    <div className="-xl:-tw-m-8">
      <Header />
      <Filters />
      <div className="tw-mb-6 tw-grid tw-grid-cols-2 tw-gap-6 -xl:tw-mb-4 -xl:tw-gap-4 -xl:tw-px-4 -md:tw-grid-cols-1">
        <AudienceOverview />
        <EngagementFunnel />
        <Devices className="-2xl:tw-col-span-1" />
        <TrafficType />
      </div>
      <ReadersOverview />
      <VersionsTable />
      {showPlaceholder && <PlaceholderDataNote />}
    </div>
  );
};

export default Analytics;
